import { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Select } from 'components/common/form';

const GroupFollowSelectCourses = connect(state => ({
  messages: state.messages
}))(class extends Component {
  handleChange = async (value) => {
    await this.props.updateUsers({page: 1, showAllCourses: value});
  }

  render() {
    const { messages } = this.props;

    const initialValues = {showAllCourses: true};

    return (
      <div className="filter">
        <Form initialValues={initialValues}>
          {({ formState }) => (
            <Select
              dropdownStyles={true}
              field="showAllCourses"
              id="group-follow-show-all-courses"
              onChange={this.handleChange}
              options={[{
                label: messages.commonShowAllCourses,
                value: true
              }, {
                label: messages.groupsCoursesShow,
                value: false
              }]}
            />
          )}
        </Form>
      </div>
    );
  }
}); 

export default GroupFollowSelectCourses;
